import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';

function FinListCard({
  as = 'div',
  children,
  className,
  padding = 'p-6',
  hover = true,
  variant = 'default',
  bleed = false,
  ...rest
}) {
  const Component = as;
  const variantClass = {
    default: 'finlist-card bg-white/90 dark:bg-slate-900/80',
    gradient: 'finlist-card finlist-card--gradient text-white shadow-finlist-lg',
    surface: 'finlist-card bg-white shadow-finlist-md dark:bg-slate-900/70'
  }[variant] || 'finlist-card';

  return (
    <Component
      className={cn(
        variantClass,
        padding,
        hover && 'finlist-hover-lift',
        bleed && 'overflow-hidden',
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}

FinListCard.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  padding: PropTypes.string,
  hover: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'gradient', 'surface']),
  bleed: PropTypes.bool
};

export default FinListCard;
